function ContentCardContainer({ children }) {
  return (
    <div className="flex flex-row flex-wrap space-3 justify-start">
      {children}
    </div>
  );
}

export default ContentCardContainer;